var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifierIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6206_33862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0257 16.2983C13.9874 17.0732 12.6994 17.532 11.3042 17.532C7.86454 17.532 5.07617 14.7436 5.07617 11.304C5.07617 7.86437 7.86454 5.076 11.3042 5.076C14.7438 5.076 17.5322 7.86437 17.5322 11.304C17.5322 12.6992 17.0734 13.9873 16.2985 15.0255L18.6606 17.3876C19.012 17.7391 19.012 18.3089 18.6606 18.6604C18.3091 19.0119 17.7392 19.0119 17.3878 18.6604L15.0257 16.2983ZM6.87617 11.304C6.87617 8.85849 8.85866 6.876 11.3042 6.876C13.7497 6.876 15.7322 8.85849 15.7322 11.304C15.7322 12.4706 15.281 13.5318 14.5437 14.3228C14.5016 14.3523 14.4614 14.386 14.4238 14.4236C14.3861 14.4613 14.3525 14.5014 14.3229 14.5435C13.532 15.2809 12.4708 15.732 11.3042 15.732C8.85865 15.732 6.87617 13.7495 6.87617 11.304Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6206_33862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierIcon);
export default __webpack_public_path__ + "static/media/magnifier_icon.81e15f3a.svg";
export { ForwardRef as ReactComponent };